// extracted by mini-css-extract-plugin
export default {"text":"icon_text__CkeAA","icon":"icon_icon__CSQkp"};